import React, { useCallback, useState } from 'react';
import { Loader2, X } from 'lucide-react';
import { S3Modal } from './v3/primitives';
// Stessi fogli scoped delle altre modali V3 (vedi CloseTicketModal).
import '../../styles/admin-v2.css';
import '../../styles/support-v3.css';

interface DeleteTicketModalProps {
  ticketNumber: string;
  busy?: boolean;
  onClose: () => void;
  onConfirm: (confirm: string) => void | Promise<void>;
}

/**
 * Conferma dell'eliminazione DEFINITIVA di un ticket (Task 24/D, solo admin con
 * `supporttickets.delete`). Il bottone si abilita solo quando l'operatore ha
 * digitato il numero del ticket: lo stesso controllo lo ripete il backend.
 */
const DeleteTicketModal: React.FC<DeleteTicketModalProps> = ({ ticketNumber, busy = false, onClose, onConfirm }) => {
  const [typed, setTyped] = useState<string>('');
  const matches = typed.trim() === ticketNumber;

  const requestClose = useCallback(() => {
    if (!busy) onClose();
  }, [busy, onClose]);

  return (
    <S3Modal open onClose={requestClose} labelledBy="s3-delete-title">
      <div className="s3-mod">
        <div className="s3-mod__head">
          <h3 className="s3-h3" id="s3-delete-title">Elimina ticket</h3>
          <button
            type="button"
            className="s3-pill s3-pill--sm s3-pill--icon"
            onClick={onClose}
            disabled={busy}
            aria-label="Chiudi"
          >
            <X size={14} />
          </button>
        </div>

        <div className="s3-mod__body">
          <p className="s3-mod__warn">
            Il ticket #{ticketNumber} e tutti i suoi messaggi, note e allegati vengono eliminati per sempre.
            Nessuno riceve avvisi. Il link del richiedente smetterà di funzionare.
          </p>
          <div className="s3-field">
            <label className="s3-label" htmlFor="s3-delete-confirm">
              Digita {ticketNumber} per confermare
            </label>
            <input
              id="s3-delete-confirm"
              type="text"
              className="s3-search s3-search--plain"
              value={typed}
              autoComplete="off"
              onChange={(e) => setTyped(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && matches && !busy) onConfirm(typed.trim());
              }}
              disabled={busy}
            />
          </div>
        </div>

        <div className="s3-mod__foot">
          <button type="button" className="s3-pill" onClick={onClose} disabled={busy}>
            Annulla
          </button>
          <button
            type="button"
            className="s3-pill s3-pill--danger"
            onClick={() => {
              if (busy || !matches) return;
              onConfirm(typed.trim());
            }}
            disabled={busy || !matches}
          >
            {busy && <Loader2 size={14} className="s3-spin" />}
            Elimina definitivamente
          </button>
        </div>
      </div>
    </S3Modal>
  );
};

export default DeleteTicketModal;
